<template>
  <div class="navbar-item" :class="{'is-light': isLight, 'is-grey' : !isLight}">
    <div class="language-switch control has-icons-left" >
      <div class="select is-small" :class="{'is-light': isLight}">
        <select
            v-model="$i18n.locale"
            class="language-selector"
            :class="{'has-text-light': isLight}"
            @change="updateLanguage($i18n.locale)"
            @click.stop
        >
          <option v-for="(o, i) in getLOCALES" :key="i" :value="o.value" :selected="o.value === $i18n.locale.value"
          >{{ o.caption }}
          </option>
        </select>
      </div>
      <div class="icon is-small is-left">
        <SvgIcon icon="icon--web-application_translate" :grow-by-height="false" :class="{'is-light': isLight, 'is-primary-dark' : !isLight}"
                 style="font-size: 0.5rem"/>
      </div>
    </div>
  </div>
</template>

<script>
import {LOCALES} from "../../i18n/locales";
import SvgIcon from "../svg/SvgIcon";
import {mapGetters} from "vuex";

export default {
  name: "LanguageSwitch",
  components: {SvgIcon},
  data() {
    return {getLOCALES: LOCALES}
  },
  computed: {
    ...mapGetters(['cmsPage']),
  },
  methods: {
    updateLanguage(lang) {
      if(this.cmsPage){
        let language = this.cmsPage.languages.find(cmsLang => cmsLang.locale === this.$i18n.locale.replace('-', '_'))

        window.location = window.location.protocol + "//" + window.location.host + language.link;
      }
       else {
        let pathPrefix = lang.split('-')[0];
        if (pathPrefix === 'de') {
          pathPrefix = '';
        }


        let path = `${pathPrefix}${window.location.pathname}`;

        path = path.replace(this.$route.params.lang + '/', '').replace(this.$route.params.lang, '');

        console.log(path)
        if (path[path.length - 1] === '/') {
          path = path.substr(0, path.length - 1)
        }
        window.location.pathname = path;
      }
    }
  },
  props: {
    isLight: {
      required: false,
      default: false,
      type: Boolean
    }
  },
}
</script>

<style lang="scss">
.control.has-icons-left.language-switch {
  .icon {
    top: 10%;
  }
}

.is-light {
  .language-switch .select select {
    background-color: $grey;
  }
}

</style>